import { Component, h, Method, Prop, State } from '@stencil/core';

@Component({
  tag: 'kdx-faq',
  styleUrl: 'faq-item.scss',
  shadow: false,
})
export class FaqItem {

  @Prop() faqTitle: string;
  @Prop() faqId: string;
  @Prop() startOpen: boolean = false;
  @Prop() useLargeZone: boolean = false;
  @State() open: boolean = false;

  componentWillLoad() {
    this.open = this.startOpen;
    // If not id is provided, generate one using the faq title.
    if (!this.faqId) {
      this.faqId = this.faqTitle.replace(/[^A-Z0-9]/ig, "-");
    }

    // If hash matches this faq, start it open.
    if (window.location.hash && window.location.hash.toLowerCase() == '#' + this.faqId.toLowerCase()) {
      this.open = true;
    }
  }

  toggleFaq() {
    this.closeOtherFaqs();
    this.open = !this.open;
  }

  closeOtherFaqs() {
    const faqs = document.querySelectorAll('kdx-faq');

    faqs.forEach((faq) => {
      if (faq.faqId != this.faqId) {
        faq.closeFaq();
      }
    });
  }

  handleClick() {
    this.toggleFaq();
  }

  handleKeyPress(event: KeyboardEvent){
    if(event.key === 'Enter' || event.key === '') {
      event.preventDefault();
      this.toggleFaq();
    }
  }

  @Method() async closeFaq() {
    this.open = false;
  }

  render() {
    return (
      <div class={`kdx-faq ${this.open ? 'open' : ' '}`}>
        <h3>
          <button
            class='accordion-trigger'
            id={this.faqId}
            aria-label={`View ${this.faqTitle}`}
            aria-expanded={this.open ? 'true' : 'false'}
            aria-controls={this.faqId}
            role="button"
            tabIndex={0}
            onClick={() => {this.handleClick()}}
            onKeyPress={(e) => this.handleKeyPress(e)}>
            
            <kdx-icon class="icon"  role='presentation' icon="chevron-down" /> 
            <span class='accordion-title'>
              {this.faqTitle}
            </span>
          </button>
        </h3>

        <div class={`kdx-faq-content ${this.useLargeZone ? 'large-zone' : ' '}`}  role='region'>
          <div class="kdx-faq-content-inner accordion-panel" id={`${this.faqId}section`} aria-labelledby={this.faqId}>
            <slot />
          </div>
        </div>
      </div>
    );
  }

}
